module.exports = __webpack_public_path__ + "static/ebba-blk-ac6af46f2abe3a3c49ebe7622e90b991.jpeg";